import React from 'react';
import PropTypes from 'prop-types';

const Up = ({ active, onClick }) => (
  <div
    onClick={active ? onClick : () => {}}
    style={{ cursor: active ? 'pointer' : 'not-allowed', margin: '0px 4px' }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={active ? '#108ee9' : '#B8B8B8'}
          fillRule="nonzero"
          d="M19.65 8.24a1 1 0 1 1-1.3 1.52L13 5.172V21a1 1 0 0 1-2 0V5.176L5.65 9.759a1 1 0 0 1-1.322-.018l-.087-.09a1 1 0 0 1 .108-1.41l7.002-6a1 1 0 0 1 1.301 0z"
        />
      </g>
    </svg>
  </div>
);

Up.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Up;
